const state = {
  alert : {
    show : false,
    variant : 'success',
    message : '',
    dismissCountDown : 0,
  },
  pagination_settings : {
    perPageList : [10,20,25,30,50,100],
    itemsPerPage : 30
  }
}
const  actions = {

}
const getters = {

}
const mutations = {
  setAlert(state,data){
    state.alert.show = data.show
    state.alert.variant = data.variant
    state.alert.message = data.message
    state.alert.dismissCountDown = data.dismissCountDown
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}